import React from 'react'
import PricingPlanMultipleColor from './child/PricingPlanMultipleColor'

const PricingLayer = () => {
    return (
        <>
            {/* PricingPlanMultipleColor */}
            <PricingPlanMultipleColor />
        </>

    )
}

export default PricingLayer